module.exports = __webpack_public_path__ + "static/img/ri.80fed380.png";